export default function useUserAgent() {
    const userAgent = navigator.userAgent.toLowerCase();
    const isWxWork = /wxwork/i.test(userAgent); //企业微信
    window.isWxWork = isWxWork;
    return { isWxWork };
}
